import { Col, Row } from 'antd';
import React from 'react';

const Precificacao2 = () => (
  <>
    <Col>
      <Row>
        <Col style={{ height: '100vh', width: '100%' }}>
          <iframe
            height="100%"
            width="100%"
            title="PowerBI"
            src={
              'https://app.powerbi.com/view?r=eyJrIjoiZjE1MTg2YzEtNWVkMC00ZTZlLWI3NDQtYTA1NWJmZGJiNzgwIiwidCI6ImNiZDVjNjQyLTE5MjMtNDk2Yi1iZWMyLTU3MzI3ODdiOTg2YyJ9' ||
              ''
            }
            frameBorder="0"
            allow="fullscreen"
          />
        </Col>
      </Row>
    </Col>
  </>
);

export default Precificacao2;
